<app-loading-spinner [active]="loadingContent"></app-loading-spinner>

<form [formGroup]="form">
    <div class="row">
        <div class="col-12 col-lg-4">
            <app-masked-input [group]="form" controlName="document_number"
                [label]="userRole === 'shareholder' ? 'CNPJ da entidade' : 'CNPJ da entidade'"
                mask="00.000.000/0000-00" placeholder="00.000.000/0000-00">
            </app-masked-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-8">
            <app-input [group]="form" controlName="corporate_name"
                [isUpperCase]="true"
                [label]="userRole === 'shareholder' ? 'Razão social' : 'Razão social'">
            </app-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-6">
            <app-input [group]="form" controlName="occupation" [maxLength]="30"
                [label]="userRole === 'shareholder' ? 'Ocupação profissional' : 'Ocupação profissional'"
                placeholder="Desenvolvedor">
            </app-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-6">
            <app-input [group]="form" controlName="corporate_email"
                [label]="userRole === 'shareholder' ? 'E-mail corporativo' : 'E-mail corporativo'">
            </app-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-2">
            <app-select label="DDI" [group]="form" controlName="phone_ddi"
                [items]="DDIOptions" placeholder="00">
            </app-select>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-4">
            <app-masked-input
                [label]="userRole === 'shareholder' ? 'Número do telefone' : 'Número do telefone'"
                [group]="form" controlName="phone_number"
                mask="(00) 00000-0000||(00) 0000-0000"
                placeholder="(00) 00000-0000"></app-masked-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-2">
            <app-masked-input [group]="form" controlName="branch" label="Ramal"
                placeholder="00" mask="099">
            </app-masked-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-4 cep-container">
            <app-masked-input [group]="form" controlName="cep"
                [label]="userRole === 'shareholder' ? 'CEP' : 'CEP'"
                mask="00000-000" placeholder="00.000-000"
                (input)="handleSearchZipcode($event)">
            </app-masked-input>
            <svg-icon src="assets/images/icon-loading.svg" *ngIf="loading"
                class="app-button-icon"></svg-icon>
        </div>
    </div>
    <app-spacer [bottom]="24"></app-spacer>

    <ng-container *ngIf="zipcodeFetched">
        <div class="row">
            <div class="col-12 col-lg-6">
                <app-input [group]="form" controlName="public_place"
                    [label]="userRole === 'shareholder' ? 'Logradouro' : 'Logradouro'"
                    [maxLength]="100">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-2">
                <app-input [group]="form" controlName="number"
                    [label]="userRole === 'shareholder' ? 'Número' : 'Número'"
                    [maxLength]="20">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-4">
                <app-input [group]="form" controlName="complement"
                    [maxLength]="100" label="Complemento">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-lg-6">
                <app-input [group]="form" controlName="district"
                    [label]="userRole === 'shareholder' ? 'Bairro' : 'Bairro'"
                    [maxLength]="100">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-4">
                <app-input [group]="form" controlName="city"
                    [label]="userRole === 'shareholder' ? 'Cidade' : 'Cidade'"
                    [maxLength]="100">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-2">
                <app-select [items]="signupService.ufs" [group]="form"
                    controlName="uf"
                    [label]="userRole === 'shareholder' ? 'UF' : 'UF'">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-4">
                <app-select [items]="signupService.nationalityChocies"
                    [group]="form" controlName="country"
                    [label]="userRole === 'shareholder' ? 'País' : 'País'">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>
    </ng-container>
</form>